// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"9e417015","388":"43f8c879","426":"4133718b","453":"19a30ac3","504":"3a5521f8","748":"6472e264","798":"7b9c307a","849":"6a1c6fcb","893":"b14764ba","982":"27c37cce"}[chunkId] + ".chunk.js";
};